
















import { Component, namespace, mixins } from 'nuxt-property-decorator'
import { Context } from '@nuxt/types'
import { IMeta } from '~/assets/interfaces/meta'
import { CATALOG_API } from '~/assets/config/api-path'
import MixinGeneral from '~/assets/mixins/general'
import ComponentCatalogCategoryItem from '~/components/catalog/category/category-item.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentPageContent from '~/components/pages/content.vue'

const pageStore = namespace('page')

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentCatalogCategoryItem,
    ComponentTypographyH1,
  },
})
export default class pageCatalogIndex extends mixins(MixinGeneral) {
  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private async asyncData({ $axios }: Context) {
    const response = await $axios.$get(CATALOG_API)

    return response
  }

  private meta: IMeta | null = null
  private created(): void {
    if (this.meta) {
      this.setMeta(this.meta)
    }
  }
}
